// extracted by mini-css-extract-plugin
module.exports = {"root":"Typography_root__V-BbL","componentList":"Typography_componentList__3Xb5C","grouping":"Typography_grouping__1nEIs","component":"Typography_component__1npUH"};